import { JamFacebookSquare, MdiInstagram } from '../../assets/icons/icons';
import './Form.css';

import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';

import emailjs from 'emailjs-com';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function FormContactUs() {
  const contactFormSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, 'Name Too Short')
      .max(32, ' Name too long')
      .required('Please provide your name'),
    email: Yup.string()
      .email('Invalid email')
      .required('Please provide your email'),
    message: Yup.string()
      .min(3, 'Message too short')
      .max(200, 'Message too long')
      .required('Please enter your message'),
  });

  const handleSubmit = (values) => {
    // console.log({ values });
    emailjs
      .send(
        'contact_service',
        'contact_form',
        values,
        'user_1jNWrn0gQGJyq7ScBpmS8'
      )
      .then(
        (result) => {
          console.log(result.text);
          if (result.text === 'OK') {
            notify();
          }
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const notify = () => {
    toast.success("Email sent successfully! I'll get back to you soon.", {
      position: toast.POSITION.TOP_CENTER,
    });
  };

  return (
    <div className='form'>
      <Formik
        initialValues={{
          name: '',
          email: '',
          message: '',
        }}
        validationSchema={contactFormSchema}
        onSubmit={(values, { resetForm }) => {
          handleSubmit(values);
          resetForm({ values: '' });
        }}
      >
        {({ errors, touched }) => (
          <Form className='container-main-form-actions'>
            <div className='form-field'>
              <label htmlFor='name' className='heading-form-field'>
                Name <br />
                <Field
                  type='text'
                  name='name'
                  placeholder='Name*'
                  className='form-input-text'
                />
                {errors.name && touched.name ? (
                  <div className='message-error-form-contact-us'>
                    {errors.name}
                  </div>
                ) : null}
              </label>
            </div>

            <div className='form-field'>
              <label htmlFor='email' className='heading-form-field'>
                Email <br />
                <Field
                  type='email'
                  name='email'
                  placeholder='Email*'
                  className='form-input-text'
                />
                {errors.email && touched.email ? (
                  <div className='message-error-form-contact-us'>
                    {errors.email}
                  </div>
                ) : null}
              </label>
            </div>
            <div className='form-field input-message'>
              <label htmlFor='message' className='heading-form-field'>
                Message <br />
                <Field
                  as='textarea'
                  type='text'
                  name='message'
                  placeholder='Get in touch'
                  className='form-input-text'
                  style={{
                    height: '100px',
                  }}
                />
                {errors.message && touched.message ? (
                  <div className='message-error-form-contact-us'>
                    {errors.message}
                  </div>
                ) : null}
              </label>
            </div>

            <button
              type='submit'
              className='button button-primary form-button-send'
              // onClick={notify}
            >
              SEND
            </button>
          </Form>
        )}
      </Formik>
      <div className='container-social-links'>
        <a
          href='https://www.instagram.com/prachurya_dash/'
          target='_blank'
          className='form-social-link'
          rel='noreferrer'
        >
          <div className='form-social-icon'>
            <MdiInstagram />
          </div>
          Instagram
        </a>
        <a
          target='_blank'
          href='https://www.facebook.com/profile.php?id=100008046975410'
          className='form-social-link'
          rel='noreferrer'
        >
          <div className='form-social-icon'>
            <JamFacebookSquare />
          </div>
          Facebook
        </a>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
}
